import { BasicCalls } from '..'

class DeliveryPeriod extends BasicCalls {
    constructor() {
        super()
        this.apiRoot = 'frontend-api'
        this.apiVersion = 'public'
        this.apiBase = 'deliveryperiod'
    }
    async fetch(_url, _params) {
        return await super.fetch(_url, _params)
    }
}

export { DeliveryPeriod }
